import React from 'react'
import PropTypes from 'prop-types'

import {
  PersonContainer,
  PersonImage,
  PersonTitle,
  PersonText,
} from './styles'

const Person = ({ text, title, image, color }) => {
  return (
    <PersonContainer>
      <PersonImage
        src={image}
        alt={title}
      />

      <PersonTitle
        weight={'medium'}
        size={['18/24', '16/20', '16/20']}
        dangerouslySetInnerHTML={{ __html: title }}
      />

      <PersonText
        weight={'medium'}
        size={['18/20', '16/20', '16/20']}
        dangerouslySetInnerHTML={{ __html: text }}
        color={color}
      />
    </PersonContainer>
  )
}

Person.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
}

export default Person
